export default "<html>\n<head></head>\n<body>\n  <div>\n    <span>Hello world</span>\n  </div>\n</body>\n</html>"